import React, { ReactElement, useEffect, useState } from 'react';
import * as _ from 'lodash';
import { useDispatch } from 'react-redux';
import GemFilterModal from './GemFilterModal/GemFilterModal';
import { useAppSelector } from '../../../redux/hooks';
import { organizationActions } from '../../../redux/organization/organizationSlice';
import { RootState } from '../../../redux/store';
import { userActions } from '../../../redux/user/userSlice';
import { Titles } from '../../../utils/general-layout-util';
import { ISelectedFilterOption } from '../../../redux/gem/gemSlice';

const DefaultFilterModel = () => null;

export enum FilterType {
  DEFAULT = 'DEFAULT',
  GEM_BANK = 'GEM_BANK',
  MY_GEM_VAULT = 'MY_GEM_VAULT',
  MY_GEM_FAV = 'MY_GEM_FAV',
}
export enum ListType {
  ORGANIZATION = 'ORGANIZATION',
  USER = 'USER',
}

const FilterModels = {
  [FilterType.DEFAULT]: DefaultFilterModel,
  [FilterType.GEM_BANK]: GemFilterModal,
  [FilterType.MY_GEM_FAV]: GemFilterModal,
  [FilterType.MY_GEM_VAULT]: GemFilterModal,
};

export interface FilterData {
  owner: { label: string; value: string }[];
  organization: { label: string; value: string }[];
}

interface FilterModelProps {
  filterType: FilterType;
  open: boolean;
  onClose: () => void;
  onApply: (_filters: ISelectedFilterOption[]) => void;
  initialFilters: any;
  title?: Titles;
}

export function MapFilterTypeToTitle(title: string): FilterType {
  switch (title) {
    case Titles.GemBank:
      return FilterType.GEM_BANK;
    case Titles.MyGemFav:
      return FilterType.MY_GEM_FAV;
    case Titles.MyGemVault:
      return FilterType.MY_GEM_VAULT;
    default:
      return FilterType.DEFAULT;
  }
}

function FilterModel({
  filterType,
  open,
  onClose,
  onApply,
  initialFilters,
  title,
}: FilterModelProps): ReactElement | null {
  const Filter = FilterModels[filterType];
  const { componentStatus: orgCompStatus, organizationList } = useAppSelector((state: RootState) => state.organization);
  const { componentStatus: userCompStatus, userList } = useAppSelector((state: RootState) => state.user);
  const [listType, setListType] = useState<ListType | null>(null);

  const getOrganisationList = Boolean(_.get(orgCompStatus, 'getOrganisationList', false));
  const getUserList = Boolean(_.get(userCompStatus, 'getUserList', false));

  const data: FilterData = {
    owner: userList?.map((user) => ({ label: user.name, value: user.userId })) ?? [],
    organization:
      organizationList
        ?.slice()
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((org) => ({ label: org.name, value: org.organizationId })) ?? [],
  };
  const dispatch = useDispatch();

  const handleCallList = (listtype: ListType) => {
    setListType(listtype);
  };
  useEffect(() => {
    if (filterType === FilterType.GEM_BANK || filterType === FilterType.MY_GEM_FAV) {
      if (listType === ListType.ORGANIZATION) {
        dispatch(organizationActions.getOrganizationListAsync());
      } else if (listType === ListType.USER) {
        dispatch(userActions.getUserList());
      }
    }
  }, [listType]);

  if (!Filter) {
    return null;
  }

  return (
    <Filter
      open={open}
      onClose={onClose}
      onApply={onApply}
      initialFilters={initialFilters}
      data={data}
      title={title}
      handleCallList={handleCallList}
      loading={{ user: getUserList, organization: getOrganisationList }}
    />
  );
}

export default FilterModel;
